// Validação de telefone celular brasileiro (espelho do backend).
// Mantenha esta lógica IDÊNTICA ao backend/utils/phoneValidator.js.

const VALID_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19,
  21, 22, 24,
  27, 28,
  31, 32, 33, 34, 35, 37, 38,
  41, 42, 43, 44, 45, 46,
  47, 48, 49,
  51, 53, 54, 55,
  61, 62, 63, 64, 65, 66, 67, 68, 69,
  71, 73, 74, 75, 77, 79,
  81, 82, 83, 84, 85, 86, 87, 88, 89,
  91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

const OBVIOUS_SEQUENCES = new Set([
  '912345678', '923456789', '934567890', '945678901', '956789012',
  '900000000', '911111111', '922222222', '933333333', '944444444',
  '955555555', '966666666', '977777777', '988888888', '999999999',
  '987654321',
]);

export function onlyDigits(input) {
  return String(input || '').replace(/\D/g, '');
}

export function validateBrPhone(input) {
  const digits = onlyDigits(input);

  if (!digits) return { valid: false, error: 'Telefone é obrigatório.' };

  let phone = digits;

  if (phone.length === 12 && phone.startsWith('0')) phone = phone.slice(1);
  if (phone.length === 13 && phone.startsWith('55')) phone = phone.slice(2);

  if (phone.length !== 11) {
    return {
      valid: false,
      error: 'Telefone inválido. Use o formato (DDD) 9XXXX-XXXX, com 11 dígitos no total.',
    };
  }

  const ddd = parseInt(phone.slice(0, 2), 10);
  if (!VALID_DDDS.has(ddd)) {
    return { valid: false, error: `DDD ${String(ddd).padStart(2, '0')} não é um DDD brasileiro válido.` };
  }

  if (phone[2] !== '9') {
    return {
      valid: false,
      error: 'Número inválido. Celulares brasileiros começam com 9 após o DDD.',
    };
  }

  const subscriber = phone.slice(2);

  if (/^(\d)\1{8}$/.test(subscriber)) {
    return { valid: false, error: 'Número inválido (dígitos repetidos).' };
  }

  if (OBVIOUS_SEQUENCES.has(subscriber)) {
    return { valid: false, error: 'Número inválido.' };
  }

  return {
    valid: true,
    normalized: '55' + phone,
    formatted: `(${phone.slice(0, 2)}) ${phone.slice(2, 7)}-${phone.slice(7)}`,
  };
}

export function maskBrPhone(input) {
  const d = onlyDigits(input).slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}
